export class BWSBase {
    constructor(created, createdBy, updated, updatedBy, modified) {
        this.created = created;
        this.createdBy = createdBy;
        this.updated = updated;
        this.updatedBy = updatedBy;
        this.modified = modified || false;
    }
    toFirestore() {
        const data = { modified: true };
        if (this.created)
            data['created'] = this.created;
        if (this.createdBy)
            data['createdBy'] = this.createdBy;
    }
}
